import * as React from 'react';
import {Box, Button, Divider, Typography} from '@mui/material';
import TemplatesToolbar from './TemplatesToolbar';
import TemplatesList from './TemplatesList';
import PaginationBar from './PaginationBar';
import {TemplateStatus} from '../../../../feature/templates/types';
import {useGetTemplatesQuery} from "../../../../services/templates";
import TemplateRightMenu from "./TemplateRightMenu";

// --- mock data (replace with API/RTK Query) ---

/*
const ALL: Template[] = [
  {id: "200", name: 'testing', updatedAt: 'Oct 20, 2025 8:09 AM', status: 'inactive'},
  {id: "81", name: 'Short text Template Trucking Companies', lastEditedAt: 'Oct 19, 2025 5:00 AM', status: 'inactive'},
  {id: "199", name: 'T4est', lastEditedAt: 'Aug 28, 2025 12:19 PM', status: 'inactive'},
  // ...more
];
*/


const PAGE_SIZE = 25;

export default function TemplatesPage() {
  const [search, setSearch] = React.useState('');
  const [status, setStatus] = React.useState<'all' | TemplateStatus>('all');
  const [page, setPage] = React.useState(1);

  const {data: ALL = [],} = useGetTemplatesQuery();

  // menu state (kebab)
  const [menuAnchor, setMenuAnchor] = React.useState<HTMLElement | null>(null);
  const [menuForId, setMenuForId] = React.useState<string | null>(null);

  const filtered = React.useMemo(() => {
    const s = search.trim().toLowerCase();
    return ALL.filter((t) => {
      const passStatus = status === 'all' ? true : t.status === status;
      const passSearch = !s || `${t.name} ${t.id}`.toLowerCase().includes(s);
      return passStatus && passSearch;
    });
  }, [ALL, search, status]);

  const total = filtered.length;
  const totalPages = Math.max(1, Math.ceil(total / PAGE_SIZE));

  // clamp page if filters change
  React.useEffect(() => {
    setPage((p) => Math.min(p, totalPages));
  }, [totalPages]);

  const startIndex = (page - 1) * PAGE_SIZE;
  const pageItems = filtered.slice(startIndex, startIndex + PAGE_SIZE);

  const from = total === 0 ? 0 : startIndex + 1;
  const to = Math.min(startIndex + PAGE_SIZE, total);

  const handleMenu = (id: string, anchor: HTMLElement) => {
    setMenuForId(id);
    setMenuAnchor(anchor);
  };

  const closeMenu = () => {
    setMenuAnchor(null);
    setMenuForId(null);
  };

  return (
    <>
      <Box sx={{p: 2}}>
        <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
          <Typography variant="h4" component="div" sx={{fontWeight: 600}}>
            <b>Templates</b>
          </Typography>
          <Button variant="contained" sx={{mt: 2}} href="/template">Add Template</Button>
        </Box>

        <Divider sx={{my: 2}}/>

        <TemplatesToolbar
          search={search}
          status={status}
          onSearchChange={setSearch}
          onStatusChange={setStatus}
        />

        <Divider sx={{my: 2}}/>

        <TemplatesList items={pageItems} onMenu={handleMenu}/>

        <Divider sx={{my: 2}}/>

        <PaginationBar
          page={page}
          totalPages={totalPages}
          from={from}
          to={to}
          total={total}
          onPrev={() => setPage((p) => Math.max(1, p - 1))}
          onNext={() => setPage((p) => Math.min(totalPages, p + 1))}
          onSelectPage={(p) => setPage(p)}
        />

        <TemplateRightMenu menuForId={menuForId} menuAnchor={menuAnchor} closeMenu={closeMenu}/>

      </Box>

    </>
  );
}
